export default __webpack_public_path__ + "assets/front/scss/user-profile.bd1a1d8c641e04ededd7744574ced2da.css";